import React, { Component } from 'react';
import AuthenticationService from '../../securityUtils/AuthenticationService';
import {
  getLoggedInUser,
  getAllowedActions,
  getLoggedInUserData,
} from '../../actions/security';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { checkForUserRole } from '../../utils';
import { userRoles } from '../../constants/globals';
import LoadingIndicator from '../Reusable/LoadingIndicator';
class SigninRedirectPage extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true, errors: {} };
  }
  async componentDidMount() {
    await AuthenticationService.getToken();
    setTimeout(async () => {
      await this.props.getAllowedActions();
      await this.props.getLoggedInUser();
      await this.props.getLoggedInUserData().then((loggedInUser) => {
        if (loggedInUser?.active) {
          if (
            checkForUserRole(loggedInUser?.roles, userRoles.MDULS.value) ||
            checkForUserRole(
              loggedInUser?.roles,
              userRoles.AUTHORIZED_PERSON.value
            )
          ) {
            window.location.replace('/requestForSignetApproval');
          } else {
            window.location.replace('/');
          }
        } else {
          window.location.replace('/unauthorizedAccess');
        }
      });
    }, 4400);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }
  render() {
    return (
      <div className="signin-content-min-height mb-5">
        <LoadingIndicator />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  loggedUser: state.loggedUser,
  user: state.user,
  errors: state.errors,
});
export default withRouter(
  connect(mapStateToProps, {
    getLoggedInUser,
    getAllowedActions,
    getLoggedInUserData,
  })(SigninRedirectPage)
);
